import React from "react";
import { PERMISSIONS_MAP } from "./enums";

export default React.createContext(PERMISSIONS_MAP);
